import {
    averagePriceUpdateRequestLink,
    AveragePriceUpdateRequestLink
} from "./link/AveragePriceUpdateRequestLinkComponent";

export default function(parentModule: string): string {
    const moduleName =  `${parentModule}.components`;

    return angular.module(moduleName, [])
                  .component(AveragePriceUpdateRequestLink, averagePriceUpdateRequestLink())
                  .name;
}
